export const ATTENDANCE_TRACKING_SHIFT_STATUS = [
  {
    id: 'AVAILABLE',
    name: 'Available',
    multiOptions: ['CLOCK_ON', 'BREAK_FINISH', 'END_TASK'],
  },
  {
    id: 'NOT_LOGGED_IN',
    name: 'Logged Out',
  },
  {
    id: 'BREAK_START',
    name: 'On Break',
  },
  {
    id: 'START_TASK',
    name: 'On Task',
  },
  {
    id: 'CLOCK_OFF',
    name: 'Unavailable',
  },
];

export const SHIFT_FORM_CONSTANTS = {
  addShift: 'Add Shift',
  editShift: 'Edit Shift',
  deleteShiftHeader: 'attendance_shift_delete_title',
  deleteShiftMsg: 'attendance_shift_delete_desc',
  submitBtnText: 'attendance_shift_delete_pos_button',
  cancelBtnText: 'attendance_shift_delete_neg_button',
};

export const attendanceTrackingDetails = 'Attendance Tracking Details';
export const SELECT_DOWNLOAD_TYPE = 'Select Download Type';
export const CSV = 'CSV';
export const PDF = 'PDF';

export const ATTENDANCE_TRACKING_DEFAULT_FILTERS = {
  personnel: undefined,
  shiftStatus: ATTENDANCE_TRACKING_SHIFT_STATUS,
  date: undefined,
};
